"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeightExcludingBanner = void 0;
/**
 * description goes here
 * @param {number} [height=null] height - the height
 * @param {number} [bannerHeight=null] bannerHeight - the height of the banner
 */
var getHeightExcludingBanner = exports.getHeightExcludingBanner = function getHeightExcludingBanner() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var bannerHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (typeof height !== 'number' || typeof bannerHeight !== 'number') return 0;
  return height - bannerHeight;
};